import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram, Youtube, Music2, Send, Heart } from "lucide-react";
import Tx from "@/components/Tx";

const SOCIAL = [
  { id: "facebook",  href: "https://www.facebook.com/Eiffel65Official", icon: Facebook,  label: "Facebook"  },
  { id: "instagram", href: "https://www.instagram.com/eiffel65/",       icon: Instagram, label: "Instagram" },
  { id: "youtube",   href: "https://www.youtube.com/eiffel65",          icon: Youtube,   label: "YouTube"   },
  { id: "tiktok",    href: "https://www.tiktok.com/@eiffel65official",  icon: Send,      label: "TikTok"    },
  { id: "spotify",   href: "https://open.spotify.com/artist/0AYHwgwitB9JKVnPC8aDB1", icon: Music2, label: "Spotify" },
];

const LEGAL = [
  { label: "Imprint",          to: "/contact?type=impressum" },
  { label: "Privacy Policy",   to: "/contact?type=privacy" },
  { label: "Contact",          to: "/contact" },
  { label: "FAQ",              to: "/contact?type=faq" },
  { label: "Terms of Use",     to: "/contact?type=terms" },
];

const DISCOVER = [
  { label: "Biography", to: "/biography" },
  { label: "Albums",    to: "/albums" },
  { label: "Videos",    to: "/videos" },
  { label: "Timeline",  to: "/timeline" },
  { label: "Tour",      to: "/tour-history" },
];

const COMMUNITY = [
  { label: "Forum",     to: "/forum" },
  { label: "Live Chat", to: "/chat" },
  { label: "Fan Map",   to: "/fan-map" },
  { label: "Fan Wall",  to: "/fan-wall" },
  { label: "Gallery",   to: "/gallery" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative mt-12 sm:mt-20 border-t border-white/5">
      <div className="absolute inset-x-0 -top-px h-px bg-gradient-to-r from-transparent via-[#00AFFF]/50 to-transparent pointer-events-none" />
      <div className="absolute -top-24 left-1/2 -translate-x-1/2 w-[80%] h-32 bg-[#00AFFF]/8 blur-3xl pointer-events-none" />

      <div className="relative container mx-auto max-w-[1500px] px-4 sm:px-8 py-10 sm:py-14">
        <div className="grid sm:grid-cols-2 lg:grid-cols-12 gap-8">
          <div className="lg:col-span-5">
            <Link to="/" className="flex items-baseline gap-1.5">
              <span className="font-display font-black text-2xl sm:text-3xl tracking-tight text-white">EIFFEL</span>
              <span className="font-display font-black text-2xl sm:text-3xl tracking-tight neon-text">65</span>
            </Link>
            <p className="mt-3 text-sm text-white/55 font-body leading-relaxed max-w-md">
              <Tx>The biggest international Eiffel 65 fan community. Discography, live chat, forum, fan map and a multilingual experience.</Tx>
            </p>
            <div className="mt-5 flex items-center gap-2 flex-wrap" data-testid="footer-social">
              {SOCIAL.map((s) => (
                <a
                  key={s.id}
                  href={s.href}
                  target="_blank"
                  rel="noreferrer noopener"
                  aria-label={s.label}
                  data-testid={`footer-social-${s.id}`}
                  className="w-10 h-10 grid place-items-center rounded-full border border-white/15 text-white/75 hover:text-[#00AFFF] hover:border-[#00AFFF]/60 hover:bg-[#00AFFF]/5 transition-all"
                >
                  <s.icon size={15} />
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="text-[10px] uppercase tracking-[0.35em] text-[#00AFFF] font-bold mb-3"><Tx>Discover</Tx></div>
            <ul className="space-y-1.5 text-sm">
              {DISCOVER.map((l) => (
                <li key={l.label}><Link to={l.to} className="text-white/70 hover:text-[#00AFFF] transition"><Tx>{l.label}</Tx></Link></li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <div className="text-[10px] uppercase tracking-[0.35em] text-[#00AFFF] font-bold mb-3"><Tx>Community</Tx></div>
            <ul className="space-y-1.5 text-sm">
              {COMMUNITY.map((l) => (
                <li key={l.label}><Link to={l.to} className="text-white/70 hover:text-[#00AFFF] transition"><Tx>{l.label}</Tx></Link></li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <div className="text-[10px] uppercase tracking-[0.35em] text-[#00AFFF] font-bold mb-3"><Tx>Legal</Tx></div>
            <ul className="space-y-1.5 text-sm" data-testid="footer-legal">
              {LEGAL.map((l) => (
                <li key={l.label}>
                  <Link to={l.to} className="text-white/70 hover:text-[#00AFFF] transition"><Tx>{l.label}</Tx></Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="text-[11px] text-white/40 font-mono inline-flex items-center gap-2 text-center sm:text-left flex-wrap justify-center sm:justify-start">
            © {new Date().getFullYear()} <Tx>Eiffel 65 Fan Community</Tx>
          </div>
          <div className="text-[10px] uppercase tracking-[0.3em] text-white/35 font-bold">
            Da Ba Dee · Da Ba Daa
          </div>
        </div>
      </div>
    </footer>
  );
}
